import React, { useState, useEffect } from "react";
import { getVendorData } from "../../services/service.js";
import "../../assets/css/doctor.scss";
import "../../assets/css/pharmacy.scss";

import ListHeader from "../../molecules/ListHeader/ListHeader.js";
import DG from "../../atoms/DataTable/DataGrid.js";
import CustomPagination from "../../atoms/CustomPagination/index.jsx";
import DataGridSkeleton from "../../atoms/DataTable/DataGridSkeleton.js";

const ViewVendor = () => {
  const [loader, setLoader] = useState(true);
  const [totalVendors, setTotalVendors] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [vendorData, setVendorData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  
  const itemsPerPage = 10;

  const handleGetData = async () => {
    setLoader(true);
    try {
      const response = await getVendorData(
        "", // project_id (empty since we don't filter by project)
        currentPage,
        itemsPerPage,
        searchQuery,
        "" // vendor_id
      );
      
      if (response?.success) {
        setVendorData(response?.data || []);
        setTotalVendors(response?.pagination?.totalItems || 0);
      } else {
        setVendorData([]);
        setTotalVendors(0);
      }
    } catch (error) {
      console.error("Error fetching vendor data:", error);
      setVendorData([]);
      setTotalVendors(0);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    setLoader(true);
    const debounceTimer = setTimeout(() => {
      handleGetData();
    }, 500);

    return () => clearTimeout(debounceTimer);
  }, [currentPage, searchQuery]);

  const handleVendorsSearchChange = (value) => {
    setSearchQuery(value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="row px-[5px]">
      <div className="col-12">
        <div className="row d-flex align-items-end">
          <div className="col-12">
            <ListHeader
              mainHeading="Vendor"
              placeholder="Search"
              btnShow={true}
              linkBreadCrum="/view-vendor"
              blinkBreadCrumText="Vendor"
              blinkBreadCrumText1="View Vendor"
              searchShow={true}
              showLikeFilter={false}
              DropDown={false}
              handleProjectSearchChange={handleVendorsSearchChange}
              searchValue={searchQuery}
              showWorkerFilter={false}
              showFilter={false}
              moduleType="vendors"
            />
          </div>
        </div>
      </div>
      <div className="w-full px-2 pt-3">
        {loader ? (
          <DataGridSkeleton totalRow={10} totalCol={10} image={false} />
        ) : (
          <DG
            key={vendorData.length}
            index={9}
            loader={loader}
            data={vendorData}
            getData={handleGetData}
          />
        )}
      </div>
      {totalVendors > 0 && (
        <CustomPagination
          totalItems={totalVendors}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      )}
    </div>
  );
};

export default ViewVendor;
